import { request } from '../request';
import { StaffCreateData } from '@libs/models/talents';

export function createTalent(data: StaffCreateData) {
  const form = new FormData();
  const dataToSend: StaffCreateRequestData = {
    ...data,
    locationId: data.location.id,
    qualificationPayRates: data.qualificationPayRates.map((q) => ({
      id: q.qualification.id,
      rateType: q.rateType,
      rate: q.rate,
      specialtyPayRates: q.specialtyPayRates.map((s) => ({
        id: s.specialty.id,
        rate: s.rate,
      })),
    })),
  };
  Object.entries(dataToSend).forEach(([key, value]) => {
    if (key === 'image') {
      form.append(key, value ? (value as File) : '');
      return;
    }
    if (key === 'availableForTravelDistance') {
      form.append(key, (value as string) ?? '0');
      return;
    }
    if (typeof value === 'object' && value !== null) {
      form.append(key, JSON.stringify(value));
      return;
    }

    form.append(key, value?.toString() ?? '');
  });

  return request.post<string>('/v2/staff', form);
}

type StaffCreateRequestData = {
  image: File | null;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  address: {
    firstAddress: string;
    city: string;
    state: string;
    zipCode: string;
    secondAddress: string;
  };
  hrInfo: {
    primaryRegion: {
      city: string;
      state: string;
    };
    secondaryRegions: {
      city: string;
      state: string;
    }[];
  };
  jobTitle: string;
  locationId: string;
  qualificationPayRates: {
    id: string; //'nursequalification-00000000000000000000000000';
    rateType: string; //'Hourly';
    rate: number;
    specialtyPayRates: {
      id: string; //'speciality-00000000000000000000000000';
      rate: number;
    }[];
  }[];
  employmentType: string;
  availableForTravelDistance: number;
  workShifts: {
    dayOfWeek: string; // 'Sunday';
    startTime: string; // '00:00:00';
    duration: string; //'00:00:00';
  }[];
  contractType: string;
};
